import { ColumnHelper } from "@tanstack/react-table";

import { SuggestedWmTableItem } from "../types";
import { ActionCell } from "./action_cell";

export const createActionColumn = (columnHelper: ColumnHelper<SuggestedWmTableItem>) =>
  columnHelper.accessor((row) => row, {
    id: "action",
    header: () => null,
    enableSorting: false,
    cell: (info) => <ActionCell item={info.row.original} />
  });
